import { Component, OnInit } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CardComponent } from '../shared/card/card.component';
import { OrderFormStandardTeamsComponent } from '../forms/order-form-standard-teams/order-form-standard-teams.component';
import { OrderFormStandardSharepointComponent } from '../forms/order-form-standard-sharepoint/order-form-standard-sharepoint.component';
import { OrderFormCloneTeamsComponent } from '../forms/order-form-clone-teams/order-form-clone-teams.component';
import { GraphService } from '../_services/graph.service';
import { SharedService } from '../_services/shared.service';
import { DepartmentResDto } from '../_dtos/departmentResDto';
import { DepartmentsService } from '../_services/departments.service';
import { CategoriesService } from '../_services/categories.service';
import { OrderFormRisComponent } from '../forms/order-form-ris/order-form-ris.component';
import { AuthService } from '../_services/auth.service';
import { StatusBarComponent } from '../shared/status-bar/status-bar.component';
import { TranslateModule } from '@ngx-translate/core';
import { forkJoin, mergeMap, tap } from 'rxjs';
import { OrderFormBookingsComponent } from '../forms/order-form-bookings/order-form-bookings.component';

@Component({
  selector: 'app-create-resources',
  imports: [
    MatTabGroup,
    MatTab,
    CardComponent,
    StatusBarComponent,
    TranslateModule,
  ],
  templateUrl: './create-resources.component.html',
  standalone: true,
  styleUrl: './create-resources.component.css',
})
export class CreateResourcesComponent implements OnInit {
  private defaultDepartment: string | undefined;
  private defaultUserType: string | undefined;
  public department: DepartmentResDto | undefined;
  public category: string | undefined;

  protected readonly OrderFormStandardTeamsComponent =
    OrderFormStandardTeamsComponent;
  protected readonly OrderFormStandardSharepointComponent =
    OrderFormStandardSharepointComponent;
  protected readonly OrderFormCloneTeamsComponent =
    OrderFormCloneTeamsComponent;
  protected readonly OrderFormRisComponent = OrderFormRisComponent;
  protected readonly OrderFormBookingsComponent = OrderFormBookingsComponent;

  constructor(
    public authService: AuthService,
    private graphService: GraphService,
    private departmentsService: DepartmentsService,
    private categoriesService: CategoriesService,
    private sharedService: SharedService,
  ) {
    this.authService = authService;
  }

  ngOnInit() {
    this.graphService
      .getExtensionAttributes()
      .pipe(
        tap((data) => {
          this.defaultDepartment =
            data.onPremisesExtensionAttributes.extensionAttribute1;
          this.defaultUserType =
            data.onPremisesExtensionAttributes.extensionAttribute2;

          if (
            this.defaultDepartment === undefined ||
            this.defaultUserType === undefined
          ) {
            throw Error('Error retrieving user attributes from Graph API.');
          }

          this.graphService.setDefaultUserType(this.defaultUserType);
        }),
        mergeMap((data) => {
          // Create an array of observables to run in parallel
          return forkJoin({
            department: this.departmentsService.getDepartmentObservable(
              this.defaultDepartment!,
            ),
            departments: this.departmentsService.getDepartmentsObservable(),
            teamCategories: this.categoriesService.getCategory(
              this.defaultUserType == 'Stud' // this is case-sensitive
                ? { type: 'team', name: 'stud' }
                : { type: 'team' },
            ),
            sharepointCategories: this.categoriesService.getCategory(
              this.defaultUserType == 'Stud' // this is case-sensitive
                ? { type: 'sharepoint', name: 'stud' }
                : { type: 'sharepoint' },
            ),
          });
        }),
      )
      .subscribe({
        next: (results) => {
          this.departmentsService.setDepartment(results.department);
          this.departmentsService.setDepartments(
            results.departments.departments,
          );
          this.categoriesService.setTeamCategories(
            results.teamCategories.categories,
          );
          this.categoriesService.setSharepointCategories(
            results.sharepointCategories.categories,
          );
        },
      });
    this.graphService.getUserInformation().subscribe({
      next: (data) => {
        this.graphService.setCity(data.city);
        this.graphService.setPostalCode(data.postalCode);
      },
    });
  }
}
